<script setup lang="ts">
defineOptions({
	name: 'BallsLottery',
})

const props = defineProps({
	numbers: {
		type: Object,
		required: true,
	},
	isColor: {
		type: Boolean,
		default: true,
	},
	classContainerFirstBlock: {
		type: String,
		default: 'mx-auto flex flex-wrap smm:flex-nowrap justify-center items-center gap-x-1.5 gap-y-2.5',
	},
	classInput: {
		type: String,
		default: 'input-container',
	},
	firstBlock: {
		type: Array,
		default: () => [],
	},
})

const getFirstBlock = computed(() => {
	if (props.firstBlock.length === 0) return props.numbers.first
	return props.firstBlock
})
</script>

<template>
	<div class="flex flex-wrap sm:flex-nowrap items-end gap-y-6 sm:gap-y-0 gap-x-5 box-numbers">
		<div
			v-if="props.numbers?.prize"
			class="mx-auto flex flex-wrap smm:flex-nowrap justify-center items-center gap-1.5"
		>
			<div
				v-for="(num, index) in props.numbers?.prize"
				:key="index"
				class="h-full"
			>
				<div
					class="text-neutral-800 rounded-full flex justify-center items-center"
					:class="[
						props.classInput,
						{
							'opacity-40': num?.number === null,
							'bg-white': props.isColor,
							'bg-red-100 ': !props.isColor,
						},
					]"
				>
					<p>
						{{ num?.number === null ? '*' : num?.number }}
					</p>
				</div>
			</div>
		</div>
		<template v-else>
			<div :class="props.classContainerFirstBlock">
				<div
					v-for="(num, index) in getFirstBlock"
					:key="index"
					class="h-full flex flex-col items-center relative"
				>
					<div
						v-if="num?.isMatch"
						class="absolute -top-2 text-white text-center bg-green-500 rounded-sm flex items-center justify-center"
					>
						<UIcon
							name="i-material-symbols:check"
							class="text-xs"
							:class="{ 'opacity-40': num?.isMatch === false }"
						/>
					</div>
					<div
						class="text-neutral-800 rounded-full flex justify-center items-center"
						:class="[
							props.classInput,
							{
								'opacity-40': num?.isMatch === false || num?.number === null,
								'bg-white ': props.isColor,
								'bg-neutral-100 text-neutral-800': !props.isColor,
							},
						]"
					>
						<p>
							{{ num?.number }}
						</p>
					</div>
				</div>
				<template v-if="props.numbers?.last && props.numbers?.last.length">
					<div
						v-for="(num, index) in props.numbers?.last"
						:key="index"
						class="h-full flex flex-col items-center relative"
					>
						<div
							v-if="num?.isMatch"
							class="absolute -top-2 text-white text-center bg-green-500 rounded-sm flex items-center justify-center"
						>
							<UIcon
								name="i-material-symbols:check"
								class="text-xs"
								:class="{ 'opacity-40': num?.isMatch === false }"
							/>
						</div>
						<div
							class="border rounded-full flex justify-center items-center"
							:class="[
								props.classInput,
								{
									'opacity-40 border-yellow-300 border-opacity-10': num?.isMatch === false,
									'border-white': num?.isMatch,
									' bg-yellow-400 ': props.isColor,
									'bg-neutral-100 ': !props.isColor,
								},
							]"
						>
							<p>
								{{ num?.number }}
							</p>
						</div>
					</div>
				</template>
			</div>
		</template>
	</div>
</template>

<style lang="postcss" scoped>
.box-numbers {
	.input-container {
		@apply w-8 h-8 text-xs text-secondary-800 font-semibold;
	}
}
</style>
